/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { OrganizationStrictHttpResponse } from '../../organization-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrganizationTokenModel } from '../../models/organization-token-model';

export interface ConsumerGetByTokenPartOfOrganizationIdTokenGet$Params {
  partOfOrganizationId: string;
  token: string;
}

export function consumerGetByTokenPartOfOrganizationIdTokenGet(http: HttpClient, rootUrl: string, params: ConsumerGetByTokenPartOfOrganizationIdTokenGet$Params, context?: HttpContext): Observable<OrganizationStrictHttpResponse<OrganizationTokenModel>> {
  const rb = new RequestBuilder(rootUrl, consumerGetByTokenPartOfOrganizationIdTokenGet.PATH, 'get');
  if (params) {
    rb.path('partOfOrganizationId', params.partOfOrganizationId, {});
    rb.path('token', params.token, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as OrganizationStrictHttpResponse<OrganizationTokenModel>;
    })
  );
}

consumerGetByTokenPartOfOrganizationIdTokenGet.PATH = '/Consumer/GetByToken/{partOfOrganizationId}/{token}';
